import { FC } from "react";
import { Path, Svg } from "react-native-svg";
import { tSvgProps } from "../types";

const PdShoppingBag: FC<tSvgProps> = (props) => (
  <Svg viewBox="0 0 24 26" fill="none" {...props}>
    <Path
      d="M23.303 25.892H0L2.316 5.754h18.671l2.316 20.138Zm-21.71-1.438H21.71L19.685 7.192H3.617L1.592 24.454Z"
      fill="currentColor"
    />
    <Path
      d="M17.514 6.473h-1.448v-.575c0-2.446-1.881-4.46-4.342-4.46-2.46 0-4.342 2.014-4.342 4.46v.575H5.934v-.575C5.934 2.733 8.54 0 11.724 0s5.79 2.59 5.79 5.898v.575Z"
      fill="currentColor"
    />
  </Svg>
);

export default PdShoppingBag;
